import * as React from "react";
import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";
import PlacesDataGrid from "./PlacesDataGrid";

export default function MainGridPlaces() {
  return (
    <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
      <Grid container spacing={2} columns={12}>
        <Grid size={{ xs: 12, lg: 12 }}>
          <PlacesDataGrid />
        </Grid>
      </Grid>
    </Box>
  );
}
